function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M9.28 22.79a6.86 6.86 0 0 1-4.88-2.03 6.86 6.86 0 0 1-2.01-4.88c0-1.84.73-3.57 2.03-4.86l8.35-8.3c.98-.97 2.28-1.51 3.66-1.51h.01c1.38 0 2.69.55 3.66 1.53 2.02 2.03 2.01 5.32-.02 7.33l-7.66 7.62c-.66.65-1.53 1.01-2.45 1.01a3.486 3.486 0 0 1-2.45-5.95l5.22-5.19c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.22 5.19c-.77.77-.78 2.03 0 2.8.37.38.87.58 1.4.58s1.02-.21 1.4-.58l7.66-7.62a3.68 3.68 0 0 0 .01-5.21 3.68 3.68 0 0 0-2.6-1.09c-.98 0-1.9.38-2.6 1.07l-8.37 8.32a5.4 5.4 0 0 0-1.59 3.81c0 1.44.55 2.79 1.57 3.81a5.387 5.387 0 0 0 7.62.02l5.93-5.9c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.93 5.9c-1.34 1.33-3.1 2-4.86 2z"
  }));
};
export default Attachment;
Attachment.displayName = 'Attachment';